module.exports = __webpack_public_path__ + "img/embajador.6a4ce447.svg";